export type Language = 'en' | 'zh';

export interface Translations {
  [key: string]: {
    en: string;
    zh: string;
  };
}

/**
 * UI 文案（chrome strings）。
 * 注意：内容数据不放这里 —— 文章/项目在 content/ 目录，简历在 src/data/cv.ts。
 */
export const academicTranslations: Translations = {
  // 姓名
  'name': { en: 'Kaibin Zhang', zh: '张铠彬' },

  // 导航
  'about': { en: 'About', zh: '关于' },
  'project': { en: 'Project', zh: '项目' },
  'posts': { en: 'Posts', zh: '文章' },
  'cv': { en: 'CV', zh: '简历' },

  // 首页
  'aboutMeTitle': { en: 'About Me', zh: '关于我' },
  'aboutMeContent': {
    en: 'My name is Kaibin Zhang, I am a student of History, Politics, and Economics @ucl. My research interests are in the intersection of social science, cognitive and behavioural science, and philosophy, to understand human decision-making in social systems. I am also interested in Behavioural Economics, Information theory, and Symbolic Systems.',
    zh: '我叫张铠彬（Kaibin Zhang），是伦敦大学学院历史、政治与经济学专业的学生。我的研究兴趣在于社会科学、认知与行为科学及哲学的交叉领域，并以此理解社会系统中的人类决策。我也对行为经济学、信息论和符号系统感兴趣。'
  },
  'researchFocus': {
    en: 'I have a solid academic background and research interests in multiple fields. My research focus includes:',
    zh: '我拥有扎实的学术背景和研究兴趣，在多个领域都有深入的学习。我的研究重点包括：'
  },
  'researchItem1': { en: 'Interdisciplinary Social Science', zh: '跨学科社会科学' },
  'researchItem2': { en: 'Cognitive & Behavioural Science', zh: '认知与行为科学' },
  'researchItem3': { en: 'Philosophy, Meaning & Interpretation', zh: '哲学、意义与解释' },
  'researchItem4': { en: 'Behavioural Economics & Information Theory', zh: '行为经济学与信息论' },
  'researchAreas': { en: 'Research Areas', zh: '研究领域' },
  'history': { en: 'History', zh: '历史研究' },
  'historyDesc': {
    en: 'Focus on historical document analysis, historical event research, and historical development patterns.',
    zh: '专注于历史文献分析、历史事件研究、历史发展规律等历史学相关研究。'
  },
  'politics': { en: 'Politics', zh: '政治学' },
  'politicsDesc': {
    en: 'Political theory, policy analysis, international relations, and political systems.',
    zh: '政治理论、政策分析、国际关系、政治制度等政治学相关研究。'
  },
  'economics': { en: 'Economics', zh: '经济学' },
  'economicsDesc': {
    en: 'Economic theory, data analysis, economic models, and policy economics.',
    zh: '经济理论、数据分析、经济模型、政策经济学等经济学相关研究。'
  },
  'interdisciplinary': { en: 'Interdisciplinary Research', zh: '跨学科研究' },
  'interdisciplinaryDesc': {
    en: 'Cross-disciplinary research in history, politics, and economics, exploring connections and influences between disciplines.',
    zh: '历史、政治、经济学的交叉领域研究，探索学科间的联系与影响。'
  },
  'recentPosts': { en: 'Recent Posts', zh: '最新文章' },
  'viewAllPosts': { en: 'View All Posts', zh: '查看所有文章' },
  'currentProjects': { en: 'Current Projects', zh: '当前项目' },
  'viewAllProjects': { en: 'View All Projects', zh: '查看所有项目' },

  // Posts 页
  'postsTitle': { en: 'Writing & Research Notes', zh: '写作与研究笔记' },
  'postsSubtitle': {
    en: 'Essays, research projects and notes — on language, politics, economics, and the occasional engineering detour.',
    zh: '论文、研究项目与随笔——关于语言、政治、经济学，偶尔也有工程方向的岔路。'
  },
  'allCategories': { en: 'All', zh: '全部' },
  'noPosts': { en: 'No posts yet.', zh: '暂无文章。' },
  'readMore': { en: 'Read more', zh: '阅读全文' },
  'backToPosts': { en: 'Back to posts', zh: '返回文章列表' },
  'externalLink': { en: 'External link', zh: '外部链接' },

  // Projects 页
  'projectsTitle': { en: 'Projects', zh: '项目' },
  'projectsSubtitle': {
    en: 'Software, hardware and research work — from iOS apps to trading agents to rotor acoustics.',
    zh: '软件、硬件与研究工作——从 iOS 应用到交易智能体，再到旋翼声学。'
  },
  'statusActive': { en: 'In Progress', zh: '进行中' },
  'statusShipped': { en: 'Shipped', zh: '已发布' },
  'statusArchived': { en: 'Archived', zh: '已归档' },
  'statusContributed': { en: 'Contributor', zh: '参与贡献' },

  // CV 页分区标题
  'education': { en: 'Education', zh: '教育背景' },
  'workExperience': { en: 'Work Experience', zh: '工作经历' },
  'cvProjects': { en: 'Projects', zh: '项目经历' },
  'volunteerExperience': { en: 'Volunteer Experience', zh: '志愿经历' },
  'cvSkills': { en: 'Skills', zh: '技能' },

  // 个人空间文案
  'blogTagline': {
    en: 'Thoughts, site notes and loose ends.',
    zh: '想法、站志和一些不成体系的记录。'
  },
  'portfolioTagline': {
    en: 'Moments through a lens — London light, travels, and the everyday.',
    zh: '用镜头记录的瞬间——伦敦的光、旅途和日常。'
  },

  // 个人空间导航
  'spaceHome': { en: 'Space', zh: '空间' },
  'spaceBlog': { en: 'Blog', zh: '博客' },
  'spacePortfolio': { en: 'Portfolio', zh: '作品' },
  'spaceAbout': { en: 'About', zh: '关于' },
  'backToAcademic': { en: 'Academic Site', zh: '学术站' },
  'backToBlog': { en: 'Back to blog', zh: '返回博客' },

  // Footer
  'footerAcademic': { en: 'Academic', zh: '学术' },
  'footerPersonal': { en: 'Personal', zh: '个人' },
  'footerConnect': { en: 'Connect', zh: '联系' },
  'footerAffiliation': {
    en: 'Student @ University College London',
    zh: '伦敦大学学院在读'
  },
  'footerDegree': {
    en: 'B.A. in History, Politics, Economics',
    zh: '历史、政治与经济学 文学学士'
  },
  'allRightsReserved': { en: 'All Rights Reserved.', zh: '保留所有权利。' }
};

/** 本地化日期显示：en 保持 ISO（2026-08-09），zh 显示 2026年8月9日 */
export function formatDate(isoDate: string, language: Language): string {
  if (language !== 'zh') return isoDate;
  const [year, month, day] = isoDate.split('-').map(Number);
  if (!year || !month || !day) return isoDate;
  return `${year}年${month}月${day}日`;
}

// 获取翻译文本
export function getText(key: string, language: Language): string {
  const translation = academicTranslations[key];
  if (!translation) {
    console.warn(`Translation key "${key}" not found`);
    return key;
  }
  return translation[language];
}

// 语言上下文
export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
